import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { useEffect } from "react";
import i18n from "@/i18n";

export function cn(...inputs) { return twMerge(clsx(inputs)); }

export const tr = (obj, key = "name") => {
  if (!obj) return "";
  const l = i18n.language?.startsWith("en") ? "en" : "ar";
  return obj[`${key}_${l}`] ?? obj[`${key}_ar`] ?? obj[key] ?? "";
};

export const fmtMoney = (n, cur = "JOD") => `${Number(n || 0).toFixed(2)} ${cur}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleString(i18n.language?.startsWith("en") ? "en-GB" : "ar-JO", { dateStyle: "medium", timeStyle: "short" }) : "");

export const STATUS_COLORS = {
  NEW: "bg-slate-100 text-slate-700", SEARCHING: "bg-cyan-50 text-cyan-700", MATCHED: "bg-cyan-50 text-cyan-700", OFFERED: "bg-blue-50 text-blue-700", CUSTOMER_SELECTED: "bg-indigo-50 text-indigo-700", PARTNER_ACCEPTED: "bg-indigo-50 text-indigo-700", AGREED: "bg-indigo-50 text-indigo-700", PAYMENT_REQUIRED: "bg-amber-50 text-amber-800", ACCEPTED: "bg-indigo-50 text-indigo-700",
  CONTACT_OPENED: "bg-emerald-50 text-emerald-700", ON_THE_WAY: "bg-teal-50 text-teal-700", ARRIVED: "bg-teal-100 text-teal-800", IN_PROGRESS: "bg-amber-50 text-amber-700", COMPLETED: "bg-green-100 text-green-800", CANCELLED: "bg-red-50 text-red-700", DISPUTED: "bg-rose-100 text-rose-800",
  pending: "bg-amber-50 text-amber-700", approved: "bg-green-100 text-green-800", rejected: "bg-red-50 text-red-700", open: "bg-amber-50 text-amber-700", resolved: "bg-green-100 text-green-800", OPEN: "bg-amber-50 text-amber-700", UNDER_REVIEW: "bg-blue-50 text-blue-700", WAITING_CUSTOMER: "bg-cyan-50 text-cyan-700", WAITING_PARTNER: "bg-cyan-50 text-cyan-700", RESOLVED: "bg-green-100 text-green-800", CLOSED: "bg-slate-100 text-slate-700",
};
export const ADMIN_ROLES = ["super_admin", "admin", "operations", "finance", "support"];
export const isStaff = (u) => !!u && ADMIN_ROLES.includes(u.role);

function setMeta(sel, attr, val) {
  let el = document.querySelector(sel);
  if (!el) {
    const m = sel.match(/^(\w+)\[(.+?)="(.+?)"\]/);
    el = document.createElement(m[1]); el.setAttribute(m[2], m[3]); document.head.appendChild(el);
  }
  el.setAttribute(attr, val);
}

export function useSeo({ title, description, canonical, schema }) {
  useEffect(() => {
    const brand = "ZEEVA PRO | زيفا برو";
    document.title = title ? `${title} — ${brand}` : `${brand} — كل خدمة ... أقرب`;
    if (description) { setMeta('meta[name="description"]', "content", description); setMeta('meta[property="og:description"]', "content", description); }
    setMeta('meta[property="og:title"]', "content", document.title);
    setMeta('link[rel="canonical"]', "href", canonical || `https://zeeva-pro.com${window.location.pathname}`);
    let s = document.getElementById("page-schema");
    if (schema) { if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; s.id = "page-schema"; document.head.appendChild(s); } s.textContent = JSON.stringify(schema); }
    else if (s) s.remove();
  }, [title, description, canonical, schema]);
}

export function getDeviceId() {
  let id = localStorage.getItem("zeeva_device");
  if (!id) { id = crypto.randomUUID(); localStorage.setItem("zeeva_device", id); }
  return id;
}
